import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';

// import { FlexLayoutModule } from '@angular/flex-layout';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FilterPipe } from 'src/app/pipes/filter.pipe';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown, faChevronUp, faInfoCircle, faEyeDropper } from '@fortawesome/free-solid-svg-icons';


import { AppComponent } from './app.component';
import { GeneralPagesComponent } from './general-pages/general-pages.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './home/home.component';
import { BtComponent } from './bt/bt.component';
import { AboutComponent } from './about/about.component';
import { NaturalEnemiesComponent } from './natural-enemies/natural-enemies.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'pests/cottonbollworm', component: GeneralPagesComponent },
  { path: 'pests/tobaccobudworm', component: GeneralPagesComponent },
  { path: 'pests/southernarmyworm', component: GeneralPagesComponent },
  { path: 'pests/fallarmyworm', component: GeneralPagesComponent },
  { path: 'pests/gardenarmyworm', component: GeneralPagesComponent },
  { path: 'pests/yellowstripedarmyworm', component: GeneralPagesComponent },
  { path: 'pests/beetarmyworm', component: GeneralPagesComponent },
  { path: 'pests/cabbagelooper', component: GeneralPagesComponent },
  { path: 'pests/soybeanlooper', component: GeneralPagesComponent },
  { path: 'pests/blackcutworm', component: GeneralPagesComponent },
  { path: 'pests/cottonaphid', component: GeneralPagesComponent },
  { path: 'pests/flowerthrips', component: GeneralPagesComponent },
  { path: 'pests/twospottedspidermites', component: GeneralPagesComponent },
  { path: 'pests/stinkbug', component: GeneralPagesComponent },
  { path: 'pests/whiteflies', component: GeneralPagesComponent },
  { path: 'pests/snails', component: GeneralPagesComponent },
  { path: 'pests', component: GeneralPagesComponent },
  { path: 'phenology', component: GeneralPagesComponent },
  { path: 'naturalenemies', component: NaturalEnemiesComponent },
  { path: 'bt', component: BtComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    GeneralPagesComponent,
    HomeComponent,
    BtComponent,
    FilterPipe,
    AboutComponent,
    NaturalEnemiesComponent,
  ],
  imports: [
    BrowserModule,
    // FlexLayoutModule,
    RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'}),
    RouterModule.forChild(routes),
    NgbModule,
    BrowserAnimationsModule,
    FormsModule,
    FontAwesomeModule
  ],
  exports: [ RouterModule, FilterPipe ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { constructor() {
  library.add(faChevronDown);
  library.add(faChevronUp);
  library.add(faInfoCircle);
  library.add(faEyeDropper);
} }
